import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { makeApi } from "./api";
import { clearViewTenant } from "./viewTenant";

export function useMe() {
  const { getToken, isSignedIn, isLoaded } = useAuth();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) {
      clearViewTenant();
      setMe(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const api = makeApi(getToken);
        const { data } = await api.get("/me");
        if (!data.is_owner) clearViewTenant();
        if (!cancelled) setMe(data);
      } catch (e) {
        if (!cancelled) setMe(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isSignedIn, isLoaded, getToken]);

  return { me, loading };
}
